import type React from "react";

import type { VenueDetails } from "../venue-dashboard-context";
import {
	useVenueSettingsContext,
	VenueSettingsContext,
} from "./use-venue-settings";

export function VenueSettingsProvider({
	children,
	...props
}: React.PropsWithChildren<{
	tenant: string;
	refetchInterval?: number;
	venue: VenueDetails;
}>) {
	return (
		<VenueSettingsContext value={useVenueSettingsContext(props)}>
			{children}
		</VenueSettingsContext>
	);
}
